/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import axios from 'axios';
import ClientImage from '../assets/maleSuggestion.png';
import CounsellorImage from '../assets/maleSuggestion2.jpg';

const hostUrl = "";

export default {

    // check here
    getUserData: () => {
        return axios.get(hostUrl + '/api/demo/isAuthenticated')
            .then(res => {
                if (res.data.user.roles[0] === "demoClient") {
                    res.data.user.profileImage = ClientImage;
                } else {
                    res.data.user.profileImage = CounsellorImage;
                }
                return { isAuthenticated: res.data.isAuthenticated, user: res.data.user };
            })
            .catch(err => {
                return { isAuthenticated: false, user: { firstName: "", lastName: "", email: "", selectedRole: "", roles: [], profileImage: "" } };
            });
    },

    registerRequest: (user) => {
        return axios.post(hostUrl + '/api/demo/demoRequest', user)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    signin: (user) => {
        return axios.post(hostUrl + '/api/demo/signin', user)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    markVisited: (page) => {
        return axios.put(hostUrl + '/api/demo/markVisited', { page: page })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    logout: () => {
        return axios.get(hostUrl + '/api/demo/logout')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    resetPassword: (email) => {
        return axios.post(hostUrl + '/api/demo/resetPassword', { email })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updatePassword: (oldPassword, newPassword) => {
        return axios.post(hostUrl + '/api/demo/updatePassword', { oldPassword, newPassword })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    }

}